import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './LoadScreen.module.scss';
import gameConstants from './gameConstants';
import * as audioBundle from './audioBundle';

export default class LoadScreen extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onChangeGame: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.waitForMediaLoaded();
    }

    async waitForMediaLoaded() {
        await audioBundle.ready;
        this.props.onChangeGame({
            ...this.props.game,
            loaded: true,
        });
    }

    render() {
        return (
            <div className={styles.loadScreen}>
                <svg
                    className={styles.spinner}
                    width='100'
                    height='100'
                    viewBox='0 0 100 100'
                >
                    <circle
                        cx='50'
                        cy='50'
                        fill='none'
                        stroke='#e15b64'
                        strokeWidth='10'
                        r='35'
                        strokeDasharray='164.93361431346415 56.97787143782138'
                    />
                </svg>
            </div>
        );
    }
}
